
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import { useSearchParams } from 'react-router-dom'
import { FinancialYearDataDDL } from '../../../../../../Components/CommonDDL/FinancialYearDataDDL'
import { MonthDataDDL } from '../../../../../../Components/CommonDDL/MonthDataDDL'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { EquipmentNameDataDDL } from '../../../../../../Components/CommonDDL/STPEquipmentNameDDL'
import { STPUnitTypeDDL } from '../../../../../../Components/CommonDDL/STPUnitTypeDDL'
import { EquipmentTypeDataDDL } from '../../../../../../Components/CommonDDL/STPEquipmentTypeDDL'
import { SeverageWorkPeriodDataDDL } from '../../../../../../Components/CommonDDL/SeverageWorkPeriodDataDDL'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../../../../Helper/Loading'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { STPPreventiveMaintainanceDeleteAPI, STPPreventiveMaintainanceTableDataAPI, STPPreventiveMaintainanceTableExportDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveMaintainanceWorkSlice'
import moment from "moment";
import { STPPreventiveMaintainanceExportData } from './STPPreventiveMaintainanceExportData'



export default function STPPreventiveMaintainanceData() {

    const userDetails = useAuthState();
    const { year, setYear,  Ward, setWard, CurrentYear, CurrentMonth  } = userDetails
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    // const [STPEquipmentMasterPopupShow, setSTPEquipmentMasterPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    // const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const d = new Date();
    let month = d.getMonth();

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: year.ID && year.ID ? year.ID : '0',
        Label: year.Label && year.Label ? year.Label : "Select...",
    })

    const [Month, setMonth] = useState({
        DDL: [],
        ID: HMonth && HMonth ? HMonth : '0',
        Label: MLable && MLable ? MLable : "Select...",
    });

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [WorkPeriod, setWorkPeriod] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [UnitType, setUnitType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [EquipmentType, setEquipmentType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [EquipmentName, setEquipmentName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFinancialYear({
            ...FinancialYear,
            ID: 0,
            Label: 'Select...',
        })
        setMonth({
            ...Month,
            ID: 0,
            Label: 'Select...'
        })
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setWorkPeriod({
            ...WorkPeriod,
            ID: 0,
            Label: 'Select...',
        })
        setUnitType({
            ...UnitType,
            ID: 0,
            Label: 'Select...',
        })
        setEquipmentType({
            ...EquipmentType,
            ID: 0,
            Label: 'Select...',
        })
        setEquipmentName({
            ...EquipmentName,
            ID: 0,
            Label: 'Select...',
        })

        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))
        // setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: FinancialYear.ID,
            M_MonthID: Month.ID,
            // ReadingDate: Date,
            M_WardID: WardName.ID,
            M_STP_WorkPeriodID: WorkPeriod.ID,
            M_STP_UnitTypeID: UnitType.ID,
            M_STP_EquipmentTypeID: EquipmentType.ID,
            M_STP_EquipmentMasterID: EquipmentName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleSTPPreventiveMaintainanceExport: handleSTPPreventiveMaintainanceExport
        }
        dispatch(STPPreventiveMaintainanceTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.STPPreventiveMaintainanceTableData)

    const handleSTPPreventiveMaintainanceExport = () => {
        const data = {
            M_FinancialYearID: FinancialYear.ID,
            M_MonthID: Month.ID,
            // ReadingDate: Date,
            M_WardID: WardName.ID,
            M_STP_WorkPeriodID: WorkPeriod.ID,
            M_STP_UnitTypeID: UnitType.ID,
            M_STP_EquipmentTypeID: EquipmentType.ID,
            M_STP_EquipmentMasterID: EquipmentName.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(STPPreventiveMaintainanceTableExportDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.STPPreventiveMaintainanceTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_STP_PreventiveMaintenanceID: item.t_stP_PreventiveMaintenanceID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(STPPreventiveMaintainanceDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.STPPreventiveMaintainanceDelete)


    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Preventive Maintainance</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <STPPreventiveMaintainanceExportData
                                                ExcelData={ExportTableData}
                                                name='Preventive Maintainance'
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12 mb-5">

                                        <div className="row py-1 rounded2">
                                            <div className="col-12 col-md-3 col-lg-3">
                                                <FinancialYearDataDDL
                                                    FinancialYear={FinancialYear}
                                                    setFinancialYear={setFinancialYear}
                                                    HYear={HYear}
                                                    YLable={YLable}
                                                />
                                            </div>
                                            <div className="col-12 col-md-3 col-lg-3">
                                                <MonthDataDDL
                                                    Month={Month}
                                                    setMonth={setMonth}
                                                    MLable={MLable}
                                                    HMonth={HMonth}
                                                    Flag='Month'
                                                />
                                            </div>

                                            <div className="col-lg-3 col-md-3">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-3">
                                                <SeverageWorkPeriodDataDDL
                                                    WorkPeriod={WorkPeriod}
                                                    setWorkPeriod={setWorkPeriod}

                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-3">
                                                <STPUnitTypeDDL
                                                    UnitType={UnitType}
                                                    setUnitType={setUnitType}

                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-3">
                                                <EquipmentTypeDataDDL
                                                    EquipmentType={EquipmentType}
                                                    setEquipmentType={setEquipmentType}
                                                    UnitType={UnitType}
                                                // ScreenName={ScreenName}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-3">
                                                <EquipmentNameDataDDL
                                                    EquipmentName={EquipmentName}
                                                    setEquipmentName={setEquipmentName}
                                                    WardName={WardName}
                                                    EquipmentType={EquipmentType}
                                                // UnitType='0'
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-12 col-lg-3 col-md-3 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Work Done Date</th>
                                                        <th>Month</th>
                                                        <th>Unit Type</th>
                                                        <th>Equipment Type</th>
                                                        <th>Equipment Name</th>
                                                        <th>Work Name </th>
                                                        <th className='action_icon action-col'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr>
                                                                <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td className='date-col'>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td>{item.month_Name ? item.month_Name : '-'}</td>
                                                                <td>{item.unitType ? item.unitType : '-'}</td>
                                                                <td>{item.equipmentType ? item.equipmentType : '-'}</td>
                                                                <td>{item.equipmentDetails ? item.equipmentDetails : '-'}</td>
                                                                <td>{item.equipmentName ? item.equipmentName : '-'}</td>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                        // onClick={() => handleEditOnClick()}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={8}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>



    )
}